import {AbstractModel} from '../../abstract-model';

export class WidgetList extends AbstractModel {
  identifier: string | null = null;
  name: string | null = null;
  description: string | null = null;
}
